import { IMAGE_POSITION_OPTIONS } from "../../lib/image-position";

const CTAFields = {
  headline: {
    type: "custom",
    label: "Headline",
    metadata: {
      source: "ai",
      description: "Compelling call-to-action headline (6-10 words)",
      seo: true,
      key: "cta.headline",
    },
  },
  subheadline: {
    type: "custom",
    label: "Subheadline (optional)",
    metadata: {
      source: "ai",
      description: "Supporting text for the CTA (15-25 words)",
      seo: true,
      key: "cta.subheadline",
    },
  },
  ctaText: {
    type: "text",
    label: "Primary CTA Button Text",
    metadata: {
      source: "ai",
      description: "Action-oriented button text (2-3 words)",
    },
  },
  ctaUrl: {
    type: "text",
    label: "Primary CTA URL",
    metadata: {
      source: "manual",
    },
  },
  secondaryCtaText: {
    type: "text",
    label: "Secondary CTA Text (optional)",
    metadata: {
      source: "context", // Derived from business phone (e.g., "Call Us: (555) 123-4567")
      contextKey: "business.phone",
      description: "Phone call CTA - auto-generated from business phone",
    },
  },
  secondaryCtaUrl: {
    type: "text",
    label: "Secondary CTA URL (optional)",
    metadata: {
      source: "manual",
    },
  },
  backgroundImage: {
    type: "custom",
    label: "Background Image",
    metadata: {
      source: "context", // Auto-selected from stock images matching business type
      contextKey: "stockImages.cta",
      description: "Background image URL",
      seo: false,
    },
  },
  imagePosition: {
    type: "select",
    label: "Image Focus",
    options: [...IMAGE_POSITION_OPTIONS],
    metadata: {
      source: "manual",
      description: "Which part of the background image stays visible when the band crops it",
    },
  },
  overlay: {
    type: "select",
    label: "Background Style",
    options: [
      { label: "Primary Color", value: "primary" },
      { label: "Dark Overlay", value: "dark" },
      { label: "Gradient", value: "gradient" },
    ],
    metadata: {
      source: "manual",
    },
  },
  overlayDarkness: {
    type: "number",
    label: "Overlay darkness",
    min: 0,
    max: 100,
    step: 5,
    metadata: {
      source: "manual",
      default: 50,
      description: "How dark the overlay is over the background photo. Lower shows more of the photo; higher makes the text easier to read.",
    },
  },
  variant: {
    type: "select",
    label: "CTA Variant",
    options: [
      { label: "Band", value: "band" },
      { label: "Card", value: "card" },
      { label: "Split", value: "split" },
    ],
    metadata: {
      source: "manual",
      description: "Controls layout and surface treatment without changing the core CTA copy.",
    },
  },
  showTrustSignals: {
    type: "radio",
    label: "Show Trust Signals",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
    metadata: {
      source: "manual",
    },
  },
  trustSignals: {
    type: "array",
    label: "Trust Signals",
    metadata: {
      source: "ai", // AI-generated trust signals specific to the business
      description: "Key trust indicators (3-4 items)",
      seo: true,
      key: "cta.trustSignals",
    },
    getItemSummary: (item: { text: string }) => item.text || "New Signal",
    arrayFields: {
      text: {
        type: "text",
        label: "Signal Text",
      },
      icon: {
        type: "custom",
        label: "Icon (optional)",
        metadata: {
          format: "lucide-icon",
          description: "Lucide React icon name (e.g. 'CheckCircle', 'Shield', 'Award', 'Clock')",
        },
      },
    },
    defaultItemProps: {
      text: "New Trust Signal",
      icon: "CheckCircle",
    },
  },
} as const;

export { CTAFields };
